module.exports = __webpack_public_path__ + "static/media/nectario-3009collage1.8aedcb21.jpg";